import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { TrustStrip } from '../components/TrustStrip';
import { CareerTimeline } from '../components/CareerTimeline';
import { Credentials } from '../components/Credentials';
import { ContactSection } from '../components/ContactSection';
export function ExperiencePage() {
  return <>
      <PageHeader label="Career Timeline" title="Progression across leading global enterprises" description="Expand any role to see dates, location, and the three achievements that mattered most." data-id="element-460" data-mp="15re5sn1e9xie" />
      <TrustStrip data-id="element-461" data-mp="i2mmym9p2ria" />
      <CareerTimeline showLabel={false} data-id="element-462" data-mp="i23dlty41bfv" />
      <Credentials data-id="element-463" data-mp="i11tkzz49em0" />
      <ContactSection data-id="element-464" data-mp="i4zd3mplw86f" />
    </>;
}